import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { getPreferredFormattedTimeSeconds } from "../../../utils/preferences";

const HEADERS = [
  { key: "offset", label: "Offset", width: 70 },
  { key: "target", label: "Target", width: 70 },
  { key: "lapTime", label: "Lap Time", width: 90 },
] as const;

export default function OffsetPreviewsTable({
  carColour,
}: {
  carColour: string;
}) {
  const offsetPreviews = useSelector(
    (state: RootState) => state.raceData[carColour]?.offsetPreviews ?? [],
    isEqual,
  );

  return (
    <div className={styles.container}>
      <table>
        <colgroup>
          {HEADERS.map((header) => (
            <col key={header.key} style={{ width: `${header.width}px` }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {HEADERS.map((header) => (
              <th key={header.key}>{header.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {offsetPreviews.length > 0
            ? offsetPreviews.map((preview, index) => (
                <tr key={index}>
                  <td>{preview.offset}</td>
                  <td>
                    {preview.target !== null ? preview.target.toFixed(2) : "-"}
                  </td>
                  <td>
                    {preview.lapTime !== null
                      ? getPreferredFormattedTimeSeconds(preview.lapTime)
                      : "-"}
                  </td>
                </tr>
              ))
            : [-1, 0, 1].map((offset) => (
                <tr key={offset}>
                  <td>{offset}</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  );
}
